"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.112 15.128L20 17.808H4l1.888-2.68v-5.04a6.14 6.14 0 014.54-5.938v-.57c0-.872.705-1.58 1.572-1.58.867 0 1.572.708 1.572 1.58v.567a6.143 6.143 0 014.54 5.941v5.04zm-3.58 4.327A2.539 2.539 0 0112 22a2.54 2.54 0 01-2.53-2.545h5.062z" }), "Notification");
//# sourceMappingURL=Notification.js.map